import { View } from "binder"
import { OPCEditorViewModel } from "./opcEditor-viewModel"
import { ProductSelector } from "src/erp/inventory/rawData/product/productSelector";

export class OpcEditorView extends View<OPCEditorViewModel> {
    GetViewUniqueId(): string {
        return "V-EFB2161C-175E-4948-AE73-DCD26437726E"
    }
    loadHtml(): string {
        let element = require('./opcEditor.html').default;
        let style = require('./opcEditor.less');
        return element;
    }
    constructor() {
        super();
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set isDisable(v: boolean) { this._isDisable = v; } public get isDisable(): boolean { return this._isDisable; } private _isDisable: boolean;
    public set productId(v: string) { this._productId = v; } public get productId(): string { return this._productId; } private _productId: string;
    public set productSelector(v: ProductSelector) { this._productSelector = v; } public get productSelector(): ProductSelector { return this._productSelector; } private _productSelector: ProductSelector;
    public set canEdit(v: boolean) { this._canEdit = v; } public get canEdit(): boolean { return this._canEdit; } private _canEdit: boolean;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    back() {
        this.dataContext.back();
    }

    save() {
        this.dataContext.save();
    }
}
